// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dshop-exception{margin:0 auto;padding:.31rem 0;text-align:center;width:12.8rem}.dshop-exception__icon{height:2.04rem;width:2.04rem}.dshop-exception__text{color:#000;font-size:.16rem;font-weight:500;margin:.23rem 0}.dshop-exception .action-btn{background-color:var(--primary-500);color:#fff;width:2.11rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
